import { dasModal } from "../modal_v2.js";
import { identityService } from "./identityService_v2.js";
import { scoreBoard } from "../scoreBoard/scoreBoard_v2.js";
import { colors } from "../colors_v2.js";
import { profile } from "./profile_v2.js";
import { eventHub } from "../eventHub_v2.js";
import { board } from "../game/gameBoard_v2.js";
import { escapeHtml } from "../escapeHtml_v2.js";

const changeNamePopState = { userID: "notSet" };

// userID could be the pAIdentity, or a temporary identity
const render = async (userID) => {
  changeNamePopState.userID = userID;
  const identity = (await identityService.getIdentity(userID)).identity;
  const namePart = identityService.parseName(identity.name);
  const blurb = Object.keys(identity).includes("blurb")
    ? identity.blurb
    : "Not Entered";
  const html = `
    <div class="popUpHead">Change Name</div>
    <div class="noWrap center">Name: <span class="courier">${escapeHtml(namePart)}</span></div><br>
    <div class="noWrap center">Blurb: <span class="courier">${escapeHtml(blurb)}</span></div><br>
    <div id="tempNameform">
      <div class="center">
        <label for="tempNameInput">New Name:</label><br>
        <input class="bottom7" type="text" id="tempNameInput">
        <div class="inputMessages center" id="tempNameInputMessage"></div>
      </div>
      <div class="center">
        <label for="blurbInput">New Blurb:</label><br>
        <input class="bottom7" type="text" id="blurbInput" placeholder="Helps others recognize you">
        <div class="inputMessages center" id="blurbInputMessage"></div>
      </div>
      <div class="center">
        <button type="submit" id="tempNameSubmit" class="submitButton bottom7 button workADayButtons">Submit</button>
        <div class="inputMessages center" id="submitMessage"></div>
        <br>
        <br>
        <div id="tempNameInfo"><em></em></div>
      </div>
    </div>
  `;

  dasModal.render(html);
  const tempNameInput = document.getElementById("tempNameInput");
  tempNameInput.style.backgroundColor = colors.getGameColor("lighterAccent");
  tempNameInput.focus();
  const blurbInput = document.getElementById("blurbInput");
  blurbInput.style.backgroundColor = colors.getGameColor("lighterAccent");
  tempNameInput.focus();
  renderTempNameInfo(userID);
};

const renderTempNameInfo = (userID) => {
  if (userID.includes("Temp_")) {
    document.getElementById("tempNameInfo").textContent =
      "Lasts until you close or refresh the browser.";
  }
};

const handleBlurbKeyUp = (event) => {
  const text = document.getElementById("blurbInput").value;
  const messageElement = document.getElementById("blurbInputMessage");
  const result = identityService.isBlurbValid(text);
  if (result.status != 200) {
    messageElement.innerText = result.message;
    return;
  }
  // if they got through all that, then
  messageElement.innerText = "";
};

const handleTempNameKeyUp = () => {
  const text = document.getElementById("tempNameInput").value;
  const messageElement = document.getElementById("tempNameInputMessage");
  const result = identityService.isNameValid(text);
  if (result.status != 200) {
    messageElement.innerText = result.message;
    return;
  }
  // if they got through all that, then
  messageElement.innerText = "";
};

const handleTempNameSubmit = async () => {
  const userID = changeNamePopState.userID;
  const nameEntered = document.getElementById("tempNameInput").value.trim();
  const blurb = document.getElementById("blurbInput").value.trim();
  const messageElement = document.getElementById("submitMessage");

  // setName will do validation, so no need to do it here before we send it:
  messageElement.innerText = "Submitting... This takes a moment.";
  const tempNameSubmit = document.getElementById("tempNameSubmit");
  if (tempNameSubmit) {
    tempNameSubmit.disabled = true;
    tempNameSubmit.style.cursor = "wait";
  }

  let params = {
    userID: userID,
    name: nameEntered,
    blurb: blurb,
  };
  document.body.style.cursor = "wait";

  const result = await identityService.setName(params);
  document.body.style.cursor = "default";

  if (tempNameSubmit) {
    tempNameSubmit.disabled = false;
    tempNameSubmit.style.cursor = "default";
  }

  messageElement.innerText = "";
  if (result.status != 200) {
    // say what's wrong (from the checks in setName, or the server)
    messageElement.innerText =
      result.error || result.message || "Unable to change the name";
    return;
  }
  // these show the temporary name, so re-render them to the new name:
  if (result.status === 200) {
    dasModal.close();
    profile.render("small");
    dasModal.render(`<div class="max">Your name has been updated</div>`);
    scoreBoard.render();
    board.render();
    changeNamePopState.userID === "notSet";
  }
};

eventHub.registerEvent("click", "tempNameSubmit", handleTempNameSubmit);
eventHub.registerEvent("keyup", "tempNameInput", handleTempNameKeyUp);
eventHub.registerEvent("keyup", "blurbInput", handleBlurbKeyUp);

export const tempNamePop = {
  render,
};
